import { Segment } from "./types";
/**
 * Based on multiple pathes points definitions, returns an Array
 * of Segments that represents the pathes
 * @param lines An array of figures which are an array of Points which are
 * a 1-dimension Array of coordinates (numbers)
 */
export var getContours = function (lines) {
    var svgSegments = [];
    lines.forEach(function (figure) {
        figure.forEach(function (f, i, array) {
            if (i != array.length - 1) {
                svgSegments.push(new Segment(f[0], f[1], array[i + 1][0], array[i + 1][1]));
            }
        });
    });
    return svgSegments;
};
